export const selectAnimalBirths = state => state.animalBirth.animalBirths

export const selectCurrentAnimalBirth = state => state.animalBirth.currentAnimal
